import { memo } from 'react';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteDistributionCenters } from 'modules/inventory/distribution-centers/hooks/useDeleteDistributionCenters';
import DistributionCentersActions from './DistributionCentersActions';

type UserStatusProps = {
  rowId: string;
};

const DistributionCentersRowActions = ({ rowId }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const { mutate, isPending, error } = useDeleteDistributionCenters(rowId, onClose);

  return (
    <>
      <DistributionCentersActions
        rowId={rowId}
        error={error}
        isLoading={isPending}
        onDelete={mutate}
        onClose={onClose}
        onOpen={onOpen}
        isOpen={isOpen}
      />
    </>
  );
};

export default memo(DistributionCentersRowActions);
